import { render, staticRenderFns } from "./PropertyAdd.vue?vue&type=template&id=47a0b3a6&scoped=true&"
import script from "./PropertyAdd.vue?vue&type=script&lang=js&"
export * from "./PropertyAdd.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAdd.vue?vue&type=style&index=0&id=47a0b3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0b3a6",
  null
  
)

export default component.exports